import React from 'react';
import { Row, Col } from 'antd';
import footer_img_produits from '../containers/assets/navBar/footer_img_produits.png';
import '../containers/css/home.css';

class Footer extends React.Component {
  render() {
    return (
      <div className="footer" style={{ marginBottom: 0, paddingBottom: 20 }}>
        <Row style={{ maxWidth: '1200px', margin: 'auto', alignItems: 'center', marginBottom: 0 }}>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <div className="footer-brand">
              <span className="footer-brand-text">l'esprit <strong>piscine</strong></span>
            </div>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8} xl={8}>
            <div className="footer-info">
              <p>34 rue Sainte Colombe, 33000 Bordeaux</p>
              <p>05 56 44 38 34 - <a href="http://www.esprit-piscine.fr" target="_blank" rel="noopener noreferrer">www.esprit-piscine.fr</a></p>
            </div>
          </Col>
          <Col xs={24} sm={24} md={6} lg={6} xl={6}>
            <div className="footer-products">
              <p className="footer-products-text">Les Fiches de Données de Sécurité des produits experts</p>
              <p className="footer-products-text">sont disponibles dans <a href="https://intranet.esprit-piscine.fr" target="_blank" rel="noopener noreferrer">l'intranet de l'esprit piscine</a></p>
              <p className="footer-products-text">&gt; Documents fournisseurs &gt; Hydrapro</p>
            </div>
          </Col>
          <Col xs={24} sm={24} md={4} lg={4} xl={4}>
            <div className="footer-image">
              <img src={footer_img_produits} alt="Produits" className="footer-products-image" />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Footer;
